export enum ReduxQueryTag {
  citizen = 'citizen',
  notify = 'notify',
  accounts = 'accounts',
  account = 'account',
  accountService = 'account-service',
  notifications = 'notifications',
  bulkNotifications = 'bulk-notifications'
}
